// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2RYtF","noInteraction":"EventWrapper_noInteraction__cdgi9","pointerPassthrough":"EventWrapper_pointerPassthrough__1VDQF"};